import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as yup from 'yup'
import { FileUpload } from 'primereact/fileupload';
import "../index.css"

// Inputs
import { TextInputField, AutoCompleteField, Button, ChipsField, TextAreaField } from '../../../helpers'
import { Toast } from 'primereact/toast'


// utils
import { getUploadedFileObj, validateInputs } from '../../../utils'
import { trimmedInputValues } from '../../../utils'

// ValidationSchema
import { MaterialItemValidation, materialItemInitialState } from '../../../validation/requestMaterialItemValidation'

import { raiseToast } from '../../../services/redux/reducers/toast/toast';

// redux apis
import { fetchMaterialProductsByCategoryId, fetchMaterialProductsUOMsByCategoryId } from '../../../services/redux/reducers/materialMaster/materialMaster'

import { sortArrayOfObjectsInAlphabeticalOrder } from '../../../utils';

const MaterialItemRequest = (props) => {
    const dispatch = useDispatch()

    const { materialItemTempObj, materialImages } = props

    const [isVariantProductUOM, setIsVariantProductUOM] = useState(true)
    //const [materialImages, setMaterialImages] = useState([])

    // suggestions states
    const [searchedMaterialCategory, setSearchedMaterialCategory] = useState([])
    const [searchedmaterialBrands, setSearchedmaterialBrands] = useState([])
    const [searchedmaterialUOMs, setSearchedmaterialUOMs] = useState([])
    const [searchedProductNames, setSearchedProductNames] = useState([])
    const [searchedVariantNames, setSearchedVariantNames] = useState([])
    const [searchedMaterialSpecifications, setSearchedMaterialSpecifications] = useState([])

    // form error state
    const [formErrors, setFormErrors] = useState([]);


    const handleSubmitMaterialItemTemp = async () => {
        let validationData = {
            "brandId": materialItemTempObj?.brandId?.brandId,
            "categoryId": materialItemTempObj?.categoryId?.categoryId,
            "UOMValue": materialItemTempObj.UOMValue,
            "keywords": materialItemTempObj.keywords,
            "remarks": materialItemTempObj.remarks,
            "materialImages": materialImages
        }

        if (typeof (materialItemTempObj.productName) === 'object') {
            validationData["productName"] = materialItemTempObj.productName.productName
        } else {
            validationData["productName"] = materialItemTempObj.productName
        }

        if (typeof (materialItemTempObj.variantName) === 'object') {
            validationData["variantName"] = materialItemTempObj.variantName.variantName
        } else {
            validationData["variantName"] = materialItemTempObj.variantName
        }

        if (typeof (materialItemTempObj.UOM) === 'object') {
            validationData["UOM"] = materialItemTempObj.UOM.UOM
        } else {
            validationData["UOM"] = materialItemTempObj.UOM
        }

        let dynamicInputValidationSchema = {}

        if (props.materialSpecificationAttributes.length > 0) {
            props.materialSpecificationAttributes.forEach((attribute) => {
                validationData[attribute.name] = materialItemTempObj[attribute.name]
                dynamicInputValidationSchema[attribute.name] = yup.string() //yup.number()
                    .test('specificationAttribute-validation', `Please enter ${attribute.name}`, value => {
                        if (attribute.mandatory && !value) {
                            return false
                        }
                        return true
                    })
            })
        }
        else {
            if (typeof (materialItemTempObj.productSpecification) === 'object') {
                validationData["productSpecification"] = materialItemTempObj?.productSpecification?.productSpecification
            } else {
                validationData["productSpecification"] = materialItemTempObj?.productSpecification
            }

            dynamicInputValidationSchema["productSpecification"] = yup.string()
                .required("Please enter product specification")
                .transform((value) => trimmedInputValues(value))
        }

        let materialItemAllInputValidation = MaterialItemValidation.concat(yup.object().shape(dynamicInputValidationSchema));

        const validationResponse = await validateInputs(materialItemAllInputValidation, validationData)
        console.log("validationResponse===", validationResponse)
        if (validationResponse) {
            if (validationResponse.error) {
                setFormErrors(validationResponse.error)
            }
            else {
                setFormErrors({})
                props.onSubmitMaterialItemTempData(validationResponse.result)
            }
        }
    }

    const searchCategory = (event) => {
        const relatedCategory = props.materialCategory.filter(category => category.categoryName.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedMaterialCategory([...relatedCategory])
    }

    const searchBrands = (event) => {
        const relatedBrand = props.materialBrands.filter(brand => brand.brandName.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialBrands([...relatedBrand])
    }

    const searchUOMs = (event) => {
        const relatedUOMs = props.materialUOMData.filter(materialUOM => materialUOM.UOM.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialUOMs([...relatedUOMs])
    }

    const searchProductNames = (event) => {
        let productNames = []
        const relatedProductNames = props.materialProductsByCaterogy.filter(product => {
            if(product.productName?.toLowerCase().includes(event.query.trim()?.toLowerCase())){
                if(!productNames.includes(product.productName?.toLowerCase())){
                    productNames.push(product.productName?.toLowerCase())
                    return true
                }
            }
        })

        setSearchedProductNames([...relatedProductNames])
    }

    const searchVariantNames = (event) => {
        let variantNames = []
        const relatedVariantNames = props.materialVariantProducts.filter(product => {
            if(product.variantName?.toLowerCase().includes(event.query.trim()?.toLowerCase())){
                if(!variantNames.includes(product.variantName?.toLowerCase())){
                    variantNames.push(product.variantName?.toLowerCase())
                    return true
                }
            }
        })

        setSearchedVariantNames([...relatedVariantNames])
    }

    const searchMaterialSpecification = (event) => {
        const relatedMaterialSpecification = props.materialSpecification.filter(specification => specification.productSpecification?.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedMaterialSpecifications([...relatedMaterialSpecification])
    }

    const handleKeyPress = (e) => {
        const regex = /^[A-Z0-9 ]+$/i

        if (!regex.test(e.key)) {
            e.preventDefault()
        }
    }

    const handleCopyPaste = (e) => {
        e.preventDefault()
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    }

    const handleDrop = (e) => {
        e.preventDefault();
    }

    const handleInputChange = (event) => {
        if(typeof (event.target.value) === "object"){
            materialItemTempObj[event.target.name] = event.target.value
        }
        else{
            if(event.target.name === 'remarks' || event.target.name === "categoryId" || event.target.name === "brandId"){
                materialItemTempObj[event.target.name] = event.target.value
            }else{
                materialItemTempObj[event.target.name] = event.target.value?.toUpperCase()
            }
        }

        if (event.target.value != null) {
            /*
            if(typeof (event.target.value) === "object"){
                materialItemTempObj[event.target.name] = event.target.value
            }
            else{
                if(event.target.name === 'remarks'){
                    materialItemTempObj[event.target.name] = event.target.value
                }else{
                    materialItemTempObj[event.target.name] = event.target.value?.toUpperCase()
                }
            }
            */
            //materialItemTempObj[event.target.name] = event.target.value
            if (event.target.name === "categoryId") {

                materialItemTempObj["productName"] = ""
                materialItemTempObj["variantName"] = ""
                materialItemTempObj["productSpecification"] = ""
                materialItemTempObj["UOM"] = ""
                materialItemTempObj["UOMValue"] = ""
                materialItemTempObj['keywords'] = []

                if (typeof (event.target.value) === "object") {
                    dispatch(fetchMaterialProductsByCategoryId(event.target.value.categoryId))
                    dispatch(fetchMaterialProductsUOMsByCategoryId(event.target.value.categoryId))
                }else{
                    const relatedCategory = props.materialCategory.find(category => category.categoryName.toLowerCase() === event.target.value?.trim().toLowerCase())
                    if(relatedCategory){
                        materialItemTempObj[event.target.name] = relatedCategory
                        dispatch(fetchMaterialProductsByCategoryId(relatedCategory.categoryId))
                        dispatch(fetchMaterialProductsUOMsByCategoryId(relatedCategory.categoryId))
                    }
                }

                props.setMaterialSpecification([])
                props.setMaterialSpecificationAttributes([])
            }
            
            if (event.target.name === "productName") {

                let relatedVariantNames = []
                if (typeof (event.target.value) === "object") {
                    relatedVariantNames = props.materialProductsByCaterogy.filter(product => product?.productName.toLowerCase() === event.target.value.productName?.trim()?.toLowerCase())
                }
                else {
                    relatedVariantNames = props.materialProductsByCaterogy.filter(product => product?.productName.toLowerCase() === event.target.value?.trim().toLowerCase())
                }
                
                let sortedVariantNames = sortArrayOfObjectsInAlphabeticalOrder(relatedVariantNames, "variantName")
                
                props.setMaterialVariantProducts(sortedVariantNames)
                props.setMaterialSpecification([])

                const relatedMaterialProductUOM = props.materialProductsUOMsByCaterogy?.find(product => {
                    let productName = ""
                    let variantName = ""
                    if (typeof (materialItemTempObj.productName) === "object") {
                        productName = materialItemTempObj.productName.productName?.trim()?.toLowerCase()
                    }
                    else {
                        productName = materialItemTempObj.productName?.trim()?.toLowerCase()
                    }

                    if (typeof (materialItemTempObj.variantName) === "object") {
                        variantName = materialItemTempObj.variantName.variantName?.trim()?.toLowerCase()
                    }
                    else {
                        variantName = materialItemTempObj.variantName?.trim()?.toLowerCase()
                    }

                    if (product.productName.toLowerCase() === productName && product.variantName.toLowerCase() === variantName) {
                        return true
                    }
                })

                materialItemTempObj["variantName"] = ""
                materialItemTempObj["UOMValue"] = ""

                if (relatedMaterialProductUOM) {
                    materialItemTempObj["UOM"] = relatedMaterialProductUOM.UOM
                    setIsVariantProductUOM(true)
                } else {
                    materialItemTempObj["UOM"] = ''
                    setIsVariantProductUOM(false)
                }
            }
            if (event.target.name === "variantName") {
                let relatedProductSpecifications = []
                if (typeof (event.target.value) === "object") {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === event.target.value.variantName?.trim()?.toLowerCase())
                }
                else {
                    relatedProductSpecifications = props.materialVariantProducts.filter(product => product.variantName?.trim()?.toLowerCase() === event.target.value?.trim()?.toLowerCase())
                }
                
                let relatedMaterialSpecificationSOPs = relatedProductSpecifications.filter(specification => specification.materialSpecificationId)
                let sortedMaterialSpecificationSOPs = sortArrayOfObjectsInAlphabeticalOrder(relatedMaterialSpecificationSOPs, "attribute")
                
                let relatedSpecifications = relatedProductSpecifications.filter(specification => !specification.materialSpecificationId)
                
                if (sortedMaterialSpecificationSOPs.length > 0) {
                    let specificationAttributes = []
                    sortedMaterialSpecificationSOPs.map(specification => {
                        let attributeObj = {
                            name: specification.attribute,
                            mandatory: specification.materialSpecificationMandatoryTypeId,
                            //unit: specification.attributeUnit
                        }
                        if(specification.attributeUnit){
                            attributeObj.unit = specification.attributeUnit
                        }
                        specificationAttributes.push(attributeObj)
                    })
                    props.setMaterialSpecificationAttributes(specificationAttributes)
                    props.setMaterialSpecification([...sortedMaterialSpecificationSOPs])
                }
                else {
                    props.setMaterialSpecificationAttributes([])
                    props.setMaterialSpecification([...relatedSpecifications])
                }

                const relatedMaterialProductUOM = props.materialProductsUOMsByCaterogy?.find(product => {
                    let productName = ""
                    let variantName = ""
                    if (typeof (materialItemTempObj.productName) === "object") {
                        productName = materialItemTempObj.productName.productName?.trim()?.toLowerCase()
                    }
                    else {
                        productName = materialItemTempObj.productName?.trim()?.toLowerCase()
                    }

                    if (typeof (materialItemTempObj.variantName) === "object") {
                        variantName = materialItemTempObj.variantName.variantName?.trim()?.toLowerCase()
                    }
                    else {
                        variantName = materialItemTempObj.variantName?.trim()?.toLowerCase()
                    }

                    if (product.productName.toLowerCase() === productName && product.variantName.toLowerCase() === variantName) {
                        return true
                    }
                })

                materialItemTempObj["productSpecification"] = ""
                materialItemTempObj["UOMValue"] = ""

                if (relatedMaterialProductUOM) {
                    materialItemTempObj["UOM"] = relatedMaterialProductUOM.UOM
                    setIsVariantProductUOM(true)
                } else {
                    materialItemTempObj["UOM"] = ''
                    setIsVariantProductUOM(false)
                }
            }
        }
        props.setMaterialItemTempObj({ ...materialItemTempObj })
    }

    const handleUploadMaterialImage = async ({ files, options }) => {
        if(files.length > 3 || (materialImages.length + files.length) > 3){
            options.clear()
            return Toast.current.show({ severity: 'error', summary: 'Error Message', detail: "Maximum upload images should be 3 only" });
        }

        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files: files, options, documentName: "MATERIAL_MASTER" })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        let uploadImages = fileArr.map(eachFile => {
            return {
                url: eachFile.objectURL,
                documentName: "MATERIAL_MASTER",
                fileName: eachFile.name,
                dataURI: eachFile.dataURI,
                objectURL: eachFile.objectURL
            }
        })

        props.setMaterialImages(prevImages => [...prevImages, ...uploadImages])
    }
  
 
    const handleRemoveMaterialImage = (url) => {
        const relatedImages = materialImages.filter(image => url !== image.url)
        props.setMaterialImages([...relatedImages])
    }

    let relatedMaterialSpecifications = props.materialSpecification.filter(specification => specification.materialSpecificationId)
    
    return (
        <div className="">
            <Toast ref={Toast} />
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="categoryId" labelText="Category" field="categoryName" placeholder="Search category" value={materialItemTempObj.categoryId} suggestions={searchedMaterialCategory} searchMethod={searchCategory} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown forceSelection errorMessage={formErrors.categoryId} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="brandId" labelText="Brand" field="brandName" placeholder="Search brand" value={materialItemTempObj.brandId} suggestions={searchedmaterialBrands} searchMethod={searchBrands} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown errorMessage={formErrors.brandId} forceSelection />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="productName" labelText="Product name" field="productName" placeholder="Search name" value={materialItemTempObj.productName} suggestions={searchedProductNames} searchMethod={searchProductNames} onChange={(e) => handleInputChange(e)} onPaste={(e)=>handleCopyPaste(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled={!materialItemTempObj.categoryId} errorMessage={formErrors.productName} /> {/* onKeyPress={(e)=>handleKeyPress(e)} */}
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="variantName" labelText="Variant name" field="variantName" placeholder="Search variant" value={materialItemTempObj.variantName} suggestions={searchedVariantNames} searchMethod={searchVariantNames} onChange={(e) => handleInputChange(e)} onPaste={(e)=>handleCopyPaste(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled={!materialItemTempObj.productName} errorMessage={formErrors.variantName} />
                </div>
                {
                    relatedMaterialSpecifications.length > 0 && relatedMaterialSpecifications.map((specification, index) => {
                        return (
                            <div key={index} className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name={specification.attribute} labelText={`${specification.attribute} ( Unit: ${specification.attributeUnit ? specification.attributeUnit : "NA"} )`} value={materialItemTempObj[specification.attribute]} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} disabled={!materialItemTempObj.variantName} errorMessage={formErrors[specification.attribute]} />
                            </div>
                        )
                    })
                }
                {
                    relatedMaterialSpecifications.length === 0 && <div className="flex flex-column col-12 mb-2 lg:col-9 lg:mb-0">
                        <AutoCompleteField name="productSpecification" labelText="Product Specification" field="productSpecification" placeholder="Search specification" value={materialItemTempObj.productSpecification} suggestions={searchedMaterialSpecifications} searchMethod={searchMaterialSpecification} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled={!materialItemTempObj.variantName} errorMessage={formErrors.productSpecification} />
                    </div>
                }
                <div className="flex col-3 pl-0 pt-0 lg:col-3 lg:mb-0">
                    <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                        <TextInputField name="UOMValue" labelText="UOM Value" keyfilter={"pnum"} value={materialItemTempObj.UOMValue} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} errorMessage={formErrors.UOMValue} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                        <AutoCompleteField name="UOM" labelText="UOM" field="UOM" placeholder="UOM" value={materialItemTempObj.UOM} suggestions={searchedmaterialUOMs} searchMethod={searchUOMs} onChange={(e) => handleInputChange(e)} onDragOver={handleDragOver}onDrop={handleDrop} dropdown disabled={isVariantProductUOM} forceSelection errorMessage={formErrors.UOM} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="flex flex-column col-8 pl-0 pt-0">
                    <div className="flex flex-column col-12">
                        <ChipsField name="keywords" labelText="Keywords" onChange={(e) => handleInputChange(e)} value={materialItemTempObj.keywords} errorMessage={formErrors.cc} />
                    </div>
                    <div className="flex flex-column col-12 text-area">
                        <TextAreaField name="remarks" labelText="Remarks" rows={3} onChange={(e) => handleInputChange(e)} value={materialItemTempObj.remarks} />
                    </div>
                </div>
                <div className="flex flex-column col-4 mt-3 align-items-end">
                    <FileUpload mode="basic" name="materialImage" accept="image/*" customUpload auto multiple chooseLabel="Upload Image" uploadHandler={(files) => handleUploadMaterialImage(files)} />
                    <div className='p-grid flex flex-wrap'>
                        {
                            materialImages.length > 0 ? materialImages.map(image => (
                                <div key={image.url} className='p-grid w-5 product-image1'>
                                    <div className=''>
                                        <img src={image.url} alt="Preview" className='w-12'/>
                                        <i className="pi pi-times delete-icon"  onClick={() => handleRemoveMaterialImage(image.url)}></i>
                                    </div>
                                </div>
                            )) : ""
                        }
                    </div>
                </div> 
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button label="Request Material Item" onClick={() => handleSubmitMaterialItemTemp()} />
            </div>
        </div>
    );
};

export default MaterialItemRequest;
